/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import dynamicHydrate from '@bluheadless/ui-logic/src/dynamic-hydration/dynamic-hydrate'
import EmptyIcon from '../../icon/empty'

export * from './project-related-icons'
export const AppleIcon = dynamicHydrate(() => import('./apple-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AppleIconSvg = dynamicHydrate(() => import('./apple-icon').then((mod) => mod.AppleIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FacebookIcon = dynamicHydrate(() => import('./facebook-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FacebookIconSvg = dynamicHydrate(() => import('./facebook-icon').then((mod) => mod.FacebookIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GoogleIcon = dynamicHydrate(() => import('./google-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GoogleIconSvg = dynamicHydrate(() => import('./google-icon').then((mod) => mod.GoogleIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GoogleColoredIcon = dynamicHydrate(() => import('./google-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GoogleColoredIconSvg = dynamicHydrate(
	() => import('./google-colored-icon').then((mod) => mod.GoogleColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const InstagramIcon = dynamicHydrate(() => import('./instagram-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const InstagramIconSvg = dynamicHydrate(() => import('./instagram-icon').then((mod) => mod.InstagramIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LinkedinIcon = dynamicHydrate(() => import('./linkedin-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LinkedinIconSvg = dynamicHydrate(() => import('./linkedin-icon').then((mod) => mod.LinkedinIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PinterestIcon = dynamicHydrate(() => import('./pinterest-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PinterestIconSvg = dynamicHydrate(() => import('./pinterest-icon').then((mod) => mod.PinterestIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SkypeIcon = dynamicHydrate(() => import('./skype-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SkypeIconSvg = dynamicHydrate(() => import('./skype-icon').then((mod) => mod.SkypeIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SnapchatIcon = dynamicHydrate(() => import('./snapchat-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SnapchatIconSvg = dynamicHydrate(() => import('./snapchat-icon').then((mod) => mod.SnapchatIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TelegramIcon = dynamicHydrate(() => import('./telegram-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TelegramIconSvg = dynamicHydrate(() => import('./telegram-icon').then((mod) => mod.TelegramIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TiktokIcon = dynamicHydrate(() => import('./tiktok-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TiktokIconSvg = dynamicHydrate(() => import('./tiktok-icon').then((mod) => mod.TiktokIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TwitterIcon = dynamicHydrate(() => import('./twitter-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TwitterIconSvg = dynamicHydrate(() => import('./twitter-icon').then((mod) => mod.TwitterIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VimeoIcon = dynamicHydrate(() => import('./vimeo-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VimeoIconSvg = dynamicHydrate(() => import('./vimeo-icon').then((mod) => mod.VimeoIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WhatsappIcon = dynamicHydrate(() => import('./whatsapp-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WhatsappIconSvg = dynamicHydrate(() => import('./whatsapp-icon').then((mod) => mod.WhatsappIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const YoutubeIcon = dynamicHydrate(() => import('./youtube-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const YoutubeIconSvg = dynamicHydrate(() => import('./youtube-icon').then((mod) => mod.YoutubeIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
